import React from 'react';
import { Button } from '@/components/ui/button';
import { Star, Trophy, Users, Zap } from 'lucide-react';
import { AddServerDialog } from './AddServerDialog';
import { ArcadeSpots } from './ArcadeSpots';
import { ServerOfTheDay } from './ServerOfTheDay';
import { useLanguage } from '@/contexts/LanguageContext';

// --- Ajoute la police pixel à ton projet (dans index.html ou _app.js)
// <link href="https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap" rel="stylesheet">
// Ou installe-la si Next.js via _document.js

export const HeroSection = () => {
  const {
    t
  } = useLanguage();
  return <section className="relative py-8 overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-4 h-4 bg-gaming-primary rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-6 h-6 bg-gaming-secondary rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-1/4 w-3 h-3 bg-gaming-accent rounded-full animate-pulse delay-2000"></div>
        <div className="absolute bottom-40 right-1/3 w-5 h-5 bg-gaming-primary rounded-full animate-pulse delay-500"></div>
      </div>

      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          
          
          {/* Message Vote 2h */}
          <div className="mb-8 inline-block">
            <div className="bg-gradient-to-r from-slate-800 to-slate-700 border border-gaming-primary/30 rounded-lg px-6 py-3">
              <p className="text-gaming-primary font-bold text-lg font-mono">
                 {t('index.voteEvery2Hours')}
              </p>
            </div>
          </div>

          {/* Arcade Spots - Publicités dynamiques */}
          <ArcadeSpots />

          {/* Server of the Day - global */}
          <ServerOfTheDay />
        </div>
      </div>
    </section>;
};